module.exports = __webpack_public_path__ + "static/media/contact_512.de5224b5.png";